import { CHATBOT_EVENTS } from "../constants";
import { ChatBotEventProperties } from "../types";
import { trackEvent } from "@src/multiCustodian/services/tracking";

/**
 * Helper function to track chatbot events in Mixpanel
 * @param eventName The name of the event to track (from CHATBOT_EVENTS)
 * @param properties Optional properties to include with the event
 */
export function trackChatbotEvent(
  eventName: typeof CHATBOT_EVENTS[keyof typeof CHATBOT_EVENTS],
  properties?: ChatBotEventProperties
): void {
  try {
    // Convert our custom event to a TrackingEvents format that the tracking service expects
    trackEvent({
      name: eventName as any, // Type assertion to support our custom events
      ...(properties && { properties: properties as any }), // Type assertion for our custom properties
    });
  } catch (error) {
    // Don't let tracking errors affect the application
    console.warn("Failed to track chatbot event:", error);
  }
}
